export const UPDATE_REQUESTS_FOR_PARTICIPATION =
  "Lädt alle requestsForParticipation";
export const UPDATE_CURRENT_REQUEST_FOR_PARTICIPATION =
  "Aktualisiert den/das aktuelle requestForParticipation";
export const OPEN_REQUEST_FOR_PARTICIPATION = "Öffne ein Teilnahmeantrag";
export const MARK_REQUEST_FOR_PARTICIPATION_ADMISSION_STATUS =
  "Marke den Admission Status des Teilnahmeantrags";
